var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorUnavailable = function SvgErrorUnavailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32.368 55.71-6.55 23.69-7.52-19.63-.66 20.67-10.4-11.52 3.01 28.07h34.83l-12.71-41.28Z",
    fill: "#192C55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m73.828 96.54 2-4a18.58 18.58 0 0 1 16.44-10.48 16.92 16.92 0 0 1 10.69 3.77l13.25 10.71",
    fill: "#28BF9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m73.368 56.36 5.56 16.68h-40.89l5.59-16.68h29.74Zm-11.13-33.35 5.57 16.68h-18.58l5.6-16.68h7.41Z",
    fill: "#FCA760"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m78.928 73.04 5.567 16.669 6.863.001-.23 6.82h-65.1l.24-6.82 6.166-.001 5.604-16.669h40.89Zm-11.12-33.35 5.56 16.67h-29.74l5.6-16.67h18.58Z",
    fill: "#FFD527"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.268 96.04v1h-118v-1h118Zm-34.82-6.96v1h-28.13v-1h28.13Z",
    fill: "#0E264C"
  })));
};
export default SvgErrorUnavailable;